import { render, staticRenderFns } from "./PFormSelectOrder.vue?vue&type=template&id=2968707b&scoped=true&"
import script from "./PFormSelectOrder.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectOrder.vue?vue&type=style&index=0&id=2968707b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968707b",
  null
  
)

export default component.exports